import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { APP } from '../../../../config';
import StateLink from '../../../StateLink';
import { Accordion } from '../../../ui/Accordion/Accordion';
import { addQueryStringParams } from '../../../../modules/url';
import { toSlugCase } from '../../../../modules/stringUtils';

import { SEARCH_URL_PREFIX, TRACKING_ATTRIBUTION } from './constants';
import { BodyText } from '../../../ui';
import {
  AccordionSectionHeaderProps,
  BasicAccordionSectionHeader,
} from '../../../ui/Accordion/AccordionSection';

export const createLink = (city, state, category, utms) => addQueryStringParams(`${SEARCH_URL_PREFIX}${toSlugCase(city)}-`
  + `${toSlugCase(state)}/${toSlugCase(category)}`, {
  ...utms,
});

const createLoc = (city, state) => `${toSlugCase(city)}-${toSlugCase(state)}`;

const SEOAccordionSectionHeader: React.FC<AccordionSectionHeaderProps> = props => (
  <BasicAccordionSectionHeader
    {...props}
    titleBodyTextProps={{
      weight: 'thin',
      textTransform: 'capitalize',
    }}
  />
);

export type SEOAccordionLocationDataProps = {
  city: string;
  cityLabel?: string;
  state: string;
  serviceCategories: string[];
};
export type SEOAccordionProps = {
  onClick: () => void;
  utmParams: Record<string, string>;
  data: SEOAccordionLocationDataProps[];
};

export const SEOAccordion = ({ onClick, utmParams, data }: SEOAccordionProps) => {
  const [expandedSections, setExpandedSections] = React.useState([]);
  const handleAccordionChange = ({ expanded }) => {
    setExpandedSections(expanded);
  };
  return (
    <Box>
      <Accordion
        expanded={expandedSections}
        onChange={handleAccordionChange}
      >
        {data.map((location, i) => (
          <Accordion.Section
            title={location.cityLabel || location.city}
            color={colors.transparent}
            seoFriendly
            key={`${location.city}-${location.state}`}
            index={i}
            HeaderComponent={SEOAccordionSectionHeader}
          >
            <Accordion.Item>
              <Inline paddingX={8} minHeight={25} space={16}>
                {location.serviceCategories.map(category => {
                  const linkParams = APP ? {
                    params: {
                      loc: createLoc(location.city, location.state),
                      q: toSlugCase(category),
                    },
                    to: 'search',
                  } : {
                    href: createLink(
                      location.city,
                      location.state,
                      category.toLowerCase(),
                      utmParams,
                    ),
                  };
                  return (
                    <StateLink
                      key={`${location.city}-${location.state}-${category}`}
                      {...linkParams}
                      clickTracking={`${TRACKING_ATTRIBUTION}_click`}
                      onClick={onClick}
                    >
                      <BodyText appearance="medium" color={colors.ash}>
                        {category}
                      </BodyText>
                    </StateLink>
                  );
                })}
              </Inline>
            </Accordion.Item>
          </Accordion.Section>
        ))}
      </Accordion>
    </Box>
  );
};

export default SEOAccordion;
